module.exports = __webpack_public_path__ + "static/media/brickwall.30093359.svg";